import { motion } from "framer-motion";

export default function Intro() {
  return (
    <section id="about" data-testid="intro-section" className="relative bg-ink py-20 sm:py-28">
      <div className="grid-bg absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-ember"
          data-testid="intro-overline"
        >
          Who We Are
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          data-testid="intro-statement"
          className="mt-8 max-w-5xl font-display text-3xl font-bold uppercase leading-[1.15] tracking-tight text-white sm:text-5xl"
        >
          We proudly serve <span className="text-ember">Northeast Ohio</span> with professional light and heavy-duty towing and recovery services. Our experienced operators provide dependable service at competitive prices.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
          data-testid="intro-hauling"
          className="mt-8 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg"
        >
          We also haul equipment of all sizes with our Landoll and 55-ton lowboy trailers.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-12 grid max-w-3xl grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-3"
          data-testid="intro-capability-chips"
        >
          {[
            ["Northeast Ohio", "Service Area"],
            ["Landoll Trailer", "Equipment Hauling"],
            ["55-Ton Lowboy", "Heavy Moves"],
          ].map(([stat, label]) => (
            <div key={label} className="bg-ink px-6 py-5">
              <div className="font-display text-xl font-extrabold uppercase text-white sm:text-2xl">{stat}</div>
              <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
